import { ActionContext } from 'vuex';
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import Overdue from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface OverdueState extends ListStateItem<Overdue>{
    editOverdue: Overdue;
    totalOverdueAmount: number;
}

class OverdueModule extends ListModuleItem<OverdueState,any,Overdue>{
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }
    
    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
       editOverdue: new Overdue(),
       totalOverdueAmount: 0
    }

    //action中 function 都是异步
    actions = {
        //分页查询
        async getAll(context: ActionContext<OverdueState, any>, payload: any) { 
            context.state.table.loading=true;
            let reponse = await $http.get('services/app/Income/GetAllOverdue', { params: payload.data });
            context.state.table.loading=false;
            let page = reponse.data.result as any;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
            context.state.totalOverdueAmount = page.totalOverdueAmount;
        },
        //导出
        async export(context: ActionContext<OverdueState, any>, payload: any) {
            await $http.post('services/app/Income/ExportOverdue', payload.data);
        },
    };

    overrideMutations = {
        
    }
}

const overdueModule = new OverdueModule();
export default overdueModule;
